import React, { useEffect } from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { WixDesignSystemProvider } from '@wix/design-system';
import { ExperimentSpec } from '../../constants/ExperimentSpec';

export const WDSWithColorBranding: React.FC = ({ children }) => {
  const { experiments, ready } = useExperiments();

  useEffect(() => {
    if (ready) {
      window.isNewColorsBrandingEnabled = experiments.enabled(ExperimentSpec.WSRNewColorsBranding);
    }
  }, [ready]);

  return ready ? (
    <WixDesignSystemProvider features={{ newColorsBranding: experiments.enabled(ExperimentSpec.WSRNewColorsBranding) }}>
      {children}
    </WixDesignSystemProvider>
  ) : null;
};
